import React, { useEffect, useState } from "react";
import { UserModel } from "../../services";
import { Badge, Box, Button, HStack } from "@chakra-ui/react";
import DataTable from "react-data-table-component";
import { CInput } from "../common";
import DeleteUserModal from "./DeleteUserModal";
import DisableUserModal from "./DisableUserModal";
import { FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function ClientsTab({ customStyles }) {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchEmail, setSearchEmail] = useState("");
  const navigate = useNavigate();

  const onDelete = (id) => {
    let newData = [...users];
    let foundIndex = users.findIndex((item) => item._id === id);
    if (foundIndex !== -1) {
      newData.splice(foundIndex, 1);
      setUsers(newData);
      newData = [...filteredUsers];
      foundIndex = filteredUsers.findIndex((item) => item._id === id);
      newData.splice(foundIndex, 1);
      setFilteredUsers(newData);
    }
  };

  const onDisable = (id) => {
    let newData = [...users];
    let foundIndex = users.findIndex((item) => item._id === id);
    if (foundIndex !== -1) {
      newData[foundIndex].isDisabled = true;
      setUsers(newData);
      newData = [...filteredUsers];
      foundIndex = filteredUsers.findIndex((item) => item._id === id);
      newData[foundIndex].isDisabled = true;
      setFilteredUsers(newData);
    }
  };

  const columns = [
    {
      name: "Full Name",
      selector: (row) => row.firstName + " " + row.lastName,
    },
    {
      name: "Email",
      selector: (row) => row.email,
    },
    {
      name: "Total Orders",
      selector: (row) => row.ordersCount,
    },
    {
      name: "Total Samples",
      selector: (row) => row.totalSamplesCount,
    },
    {
      name: "Status",
      selector: (row) => (
        <Badge colorScheme={row.isDisabled ? "red" : "green"}>
          {row.isDisabled ? "Disabled" : "Active"}
        </Badge>
      ),
    },
    {
      name: "Action",
      cell: (row) => {
        return (
          <HStack>
            <DeleteUserModal id={row._id} onDelete={onDelete} />
            <DisableUserModal id={row._id} onDisable={onDisable} />
          </HStack>
        );
      },
    },
  ];

  useEffect(() => {
    const fetch = async () => {
      try {
        let res = await UserModel.getAllByRole("user");
        setUsers(res.data.data);
        setFilteredUsers(res.data.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  const filterMethods = [
    (item) =>
      item.email.toLowerCase().indexOf(searchEmail?.toLowerCase()) != -1,
  ];

  useEffect(() => {
    if (searchEmail) {
      let searchedUsers = users.filter((item) => {
        for (let i = 0; i < filterMethods.length; i++) {
          if (!filterMethods[i](item)) {
            return false;
          }
        }
        return true;
      });
      setFilteredUsers(searchedUsers);
    } else {
      setFilteredUsers(users);
    }
  }, [searchEmail]);

  return (
    <>
      <HStack
        justifyContent="end"
        alignItems={{ base: "start", md: "center" }}
        flexDirection={{ base: "column", md: "row" }}
        mb={{ base: 0, md: "2" }}
      >
        <HStack
          gap="2"
          minW={{ base: "100%", md: "sm" }}
          flexDirection={{ base: "column", md: "row" }}
        >
          <Button
            rightIcon={<FaPlus />}
            onClick={() => navigate("/create-user")}
            bgColor="black"
            borderRadius="lg"
            fontWeight="medium"
            py="5"
            px="7"
            size="sm"
          >
            Create User
          </Button>
          <Box ps="2" borderStartWidth="1px" w="full">
            <CInput
              placeholder="Search Email"
              value={searchEmail}
              onChange={(e) => setSearchEmail(e.target.value)}
            />
          </Box>
        </HStack>
      </HStack>
      <DataTable
        columns={columns}
        data={filteredUsers}
        progressPending={loading}
        keyField="_id"
        customStyles={customStyles}
        responsive
        pagination
      />
    </>
  );
}
